import React from 'react';
import { MapPin, Navigation, Car } from 'lucide-react';
import { clinicInfo } from '../mockData';

const LocationSection = () => {
  const handleOpenMaps = () => {
    window.open(clinicInfo.googleMapsUrl, '_blank');
  };

  const handleOpenWaze = () => {
    window.open(clinicInfo.wazeUrl, '_blank');
  };

  return (
    <section id="localizacao" className="bg-white py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <p className="mb-3 text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-brand-steel">
            Visite-nos
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-brand-ink md:text-5xl">
            Onde <span className="text-brand-deep">estamos</span>
          </h2>
          <p className="mt-4 text-lg font-light text-brand-muted">
            Fácil de chegar em Paranaguá — perto do centro, com estacionamento na porta.
          </p>
          <p className="mt-3 font-medium text-brand-deep">
            Na esquina do Supermercado Pague Menos — você não erra o caminho
          </p>
        </div>

        <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-2">
          <div className="space-y-6">
            <div className="rounded-2xl border border-brand-ink/8 bg-gradient-to-br from-brand-cream/80 to-brand-wash/40 p-6 shadow-sm">
              <h3 className="mb-4 flex items-center gap-3 font-display text-xl font-semibold text-brand-ink">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-deep text-lg text-white shadow-inner-soft">
                  🏢
                </span>
                Nossa fachada
              </h3>
              <div className="relative mb-3 h-64 overflow-hidden rounded-xl bg-brand-wash shadow-md ring-1 ring-brand-ink/5">
                <img
                  src="/images/fachada-clinica.png"
                  alt="Fachada Ortodontia Líder"
                  className="h-full w-full object-cover"
                />
              </div>
              <p className="text-center text-sm text-brand-muted">
                <strong className="text-brand-ink">Referência:</strong> esquina com Pague Menos
              </p>
            </div>

            <div className="rounded-2xl border border-brand-ink/8 bg-white p-6 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-deep text-white">
                  <MapPin className="h-6 w-6" strokeWidth={1.75} />
                </div>
                <div>
                  <h3 className="font-display text-lg font-semibold text-brand-ink">Endereço</h3>
                  <p className="mt-1 leading-relaxed text-brand-muted">{clinicInfo.address}</p>
                  <p className="mt-2 text-sm font-semibold text-brand-deep">
                    Esquina com Supermercado Pague Menos
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-brand-ink/8 bg-white p-6 shadow-sm">
              <h3 className="font-display text-lg font-semibold text-brand-ink">Horário</h3>
              <div className="mt-4 space-y-2">
                <div className="flex items-center justify-between border-b border-brand-ink/10 py-2">
                  <span className="font-medium text-brand-muted">Segunda a sexta</span>
                  <span className="font-semibold text-brand-deep">09:00 – 19:00</span>
                </div>
                <div className="flex items-center justify-between py-2">
                  <span className="font-medium text-brand-muted">Sábado e domingo</span>
                  <span className="font-semibold text-brand-muted">Fechado</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <button
                type="button"
                onClick={handleOpenMaps}
                className="group flex w-full items-center justify-center gap-2 rounded-full bg-brand-deep px-6 py-4 text-sm font-semibold text-white shadow-md transition hover:bg-brand-ink hover:shadow-brand-lg"
              >
                <Navigation className="h-5 w-5 shrink-0" strokeWidth={1.75} />
                Abrir no Google Maps
                <span className="transition-transform group-hover:translate-x-0.5" aria-hidden>
                  →
                </span>
              </button>
              <button
                type="button"
                onClick={handleOpenWaze}
                className="group flex w-full items-center justify-center gap-2 rounded-full bg-[#33ccff] px-6 py-4 text-sm font-semibold text-[#0c1524] shadow-md ring-1 ring-[#0c1524]/10 transition hover:bg-[#1ab8e8] hover:shadow-brand-lg"
              >
                <Car className="h-5 w-5 shrink-0" strokeWidth={1.75} />
                Abrir no Waze
                <span className="transition-transform group-hover:translate-x-0.5" aria-hidden>
                  →
                </span>
              </button>
            </div>

            <div className="rounded-2xl border border-brand-gold/30 bg-brand-cream/60 p-6">
              <p className="text-center text-sm font-medium leading-relaxed text-brand-ink">
                Fácil de achar • Estacionamento na porta • Atendimento acolhedor
              </p>
            </div>
          </div>

          <div className="h-[500px] overflow-hidden rounded-2xl border border-brand-ink/8 shadow-brand-lg ring-1 ring-brand-ink/5">
            <iframe
              src={clinicInfo.googleMapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Ortodontia Líder"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
